var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantDropReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7274 26.5454C19.7274 28.0517 18.5063 29.2727 17.0001 29.2727C15.4939 29.2727 14.2728 28.0517 14.2728 26.5454C14.2728 25.0392 15.4939 23.8182 17.0001 23.8182C18.5063 23.8182 19.7274 25.0392 19.7274 26.5454Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15862 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM22.4779 16.3182L24.3373 17.3581C24.4915 17.4444 24.546 17.6429 24.458 17.798L24.2033 18.2474C24.1154 18.4026 23.9193 18.4538 23.7689 18.3609L21.9549 17.2408L22.0004 19.4008C22.0042 19.58 21.8626 19.7273 21.6867 19.7273H21.1773C21.0013 19.7273 20.8598 19.58 20.8635 19.4008L20.909 17.2408L19.095 18.3609C18.9446 18.4538 18.7485 18.4026 18.6606 18.2474L18.4059 17.7981C18.3179 17.6429 18.3724 17.4444 18.5266 17.3581L20.386 16.3182L18.5266 15.2782C18.3724 15.192 18.3179 14.9935 18.4059 14.8383L18.6606 14.389C18.7485 14.2338 18.9446 14.1826 19.095 14.2755L20.909 15.3956L20.8635 13.2355C20.8598 13.0564 21.0013 12.9091 21.1773 12.9091H21.6867C21.8626 12.9091 22.0041 13.0564 22.0004 13.2355L21.9549 15.3956L23.7689 14.2755C23.9193 14.1826 24.1154 14.2338 24.2033 14.389L24.458 14.8383C24.546 14.9935 24.4915 15.192 24.3373 15.2782L22.4779 16.3182ZM11.3751 21.7727L15.6365 15.6364L19.8979 21.7727L19.896 21.7744C20.6438 22.7079 21.091 23.8926 21.091 25.1818C21.091 28.1943 18.649 30.6364 15.6365 30.6364C12.624 30.6364 10.182 28.1943 10.182 25.1818C10.182 23.8926 10.6292 22.7079 11.377 21.7744L11.3751 21.7727Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantDropReport);
export default __webpack_public_path__ + "static/media/InstantDropReport.9a55bf2317ff1fae25cea39e981aae69.svg";
export { ForwardRef as ReactComponent };